import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class TaskAction extends Cloneable {
    static DEFAULT = new TaskAction(0, "DEFAULT");

    static _values = [
        TaskAction.DEFAULT,
        new TaskAction(1, "SLEEP"),
        new TaskAction(3, "ORDER"),
        new TaskAction(2, "UPGRADE"),
        new TaskAction(4, "COOLDOWN")
    ];

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, TaskAction.getValue(id));
        });
    }

    static getValues() {
        return TaskAction._values;
    }

    static getValue(id) {
        let value = TaskAction._values.find(v => v.id === id) || null;
        console.assert(value, "unknown value: " + id);
        return value;
    }

    static is(value) {
        if (value instanceof TaskAction) {
            return TaskAction._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    constructor(id = 0, name = "None") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }

    equal(value) {
        if (value instanceof TaskAction) {
            return this.id === value.id;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TaskAction());
        } else if (target instanceof TaskAction) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(TaskAction, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});